module.exports = __webpack_public_path__ + "img/33745192000203.1e6e265c.png";